import { ColumnsType } from "antd/es/table";
import { TenantDto } from "../../../../../../../shared/dto/TenantDto";

import moment from "moment";
import PermissionValidator from "../../../../../../../shared/guard/PermissionValidator";
import { PERMISSIONS } from "../../../../../../../shared/guard/Permissions";
import { FaEdit, FaExchangeAlt, FaTrash } from "react-icons/fa";
import { Flex } from "antd";

const permissionValidator = new PermissionValidator();

const columns = (
  handleEditTenantClick: (tenant: TenantDto) => void,
  handleDeleteTenantClick: (tenant: TenantDto) => void,
  handleAccessTenantClick: (tenant: TenantDto) => void
): ColumnsType<TenantDto> => [
  {
    title: "ID",
    dataIndex: "tenantId",
    key: "tenantId",
  },
  {
    title: "Nome",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Ativo",
    dataIndex: "active",
    key: "active",
    render: (active: boolean) => (active ? "Sim" : "Não"),
  },
  {
    title: "Criado em",
    dataIndex: "createdAt",
    key: "createdAt",
    render: (createdAt: string) => moment(createdAt).format("DD/MM/YYYY"),
  },
  {
    title: "Atualizado em",
    dataIndex: "updatedAt",
    key: "updatedAt",
    render: (updatedAt: string) => moment(updatedAt).format("DD/MM/YYYY"),
  },
  {
    title: "Ações",
    key: "actions",
    render: (_, tenant) => (
      <Flex align="center">
        <a onClick={() => handleEditTenantClick(tenant)}><FaEdit size={18} /></a>
        {permissionValidator.hasPermission(PERMISSIONS.ADMINISTRACAO) && (
          <>
            <a onClick={() => handleAccessTenantClick(tenant)} style={{ marginLeft: 8 }}><FaExchangeAlt size={18} /></a>
            {tenant.tenantId !== 1 && (
              <a onClick={() => handleDeleteTenantClick(tenant)} style={{ marginLeft: 25 }}><FaTrash size={16} /></a>
            )}
          </>
        )}
      </Flex>
    ),
  },
];

export default columns;
